import React from 'react';
import { motion } from 'framer-motion';
import { solutionScenarios } from '../../data/solutions';
import { demoAvailability } from '../../data/siteContent';
import { easeOutStrong, fadeUp } from '../../utils/motion';
export function SolutionsIntro() {
  return <>
      <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-2549" data-mp="1u3gzc3r9knyq">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-2550" data-mp="1z2a85ivlvqsk">
          <div className="lg:col-span-6" data-id="element-2551" data-mp="1b8a4r3bcuxkm">
            <p className="text-sm font-medium text-teal mb-5" data-id="element-2552" data-mp="1g50kfpj8zr5i">Solutions</p>
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-2553" data-mp="1g7dakpz5t7tn">
              Solutions across seven domains
            </h1>
          </div>
          <div className="lg:col-span-6 lg:pt-10" data-id="element-2554" data-mp="3ac6b3v9www98">
            <p className="text-2xl text-ink-dark leading-relaxed mb-6" data-id="element-2555" data-mp="3aamwsa7tgva3">
              SyNeural builds systems that help researchers connect ideas,
              people develop sound judgment, and institutions make decisions
              they can explain and improve.
            </p>
            <p className="text-lg text-ink-muted leading-relaxed" data-id="element-2556" data-mp="3f3xw7qaau9rz">
              Our{' '}
              <a href="/semantic-knowledge" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-2557" data-mp="2rck5tpvpko9n">
                Semantic Knowledge Platform (SKP)
              </a>{' '}
              connects concepts, documents, research, and policies into usable
              knowledge. Our{' '}
              <a href="/human-capability" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-2558" data-mp="glaez6yqjvm8">
                Human Capability Framework
              </a>
              , including CJI and NCJI, defines assessment, development, and
              opportunity guidance based on approved definitions and research.{' '}
              <a href="/noetivra" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-2559" data-mp="snk55nx9ew69">
                Noetivra
              </a>{' '}
              brings these resources into interactive views and workflows
              configured for each setting. Organizations can use each component
              where it fits or bring them together around a specific problem.
            </p>
            <p className="mt-5 text-base text-ink-dark leading-relaxed border-l-2 border-lavender pl-4" data-id="element-2560" data-mp="9vrcxvq0lezl">
              {demoAvailability}
            </p>
          </div>
        </motion.div>
      </section>

      <section className="bg-surface-bg py-16 lg:py-20 border-b border-line" data-id="element-2561" data-mp="3ddj1f04xzgt1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2562" data-mp="3ibkri50scge0">
          <motion.p {...fadeUp} className="font-heading font-bold text-2xl text-ink-dark mb-8" data-id="element-2563" data-mp="3atwfe95zaeqi">
            The approach changes with the setting.
          </motion.p>
          <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-2564" data-mp="35sfg2i3570c1">
            {solutionScenarios.map(scenario => <li key={scenario.setting} className="bg-white p-6 lg:p-8" data-id="element-2565" data-mp="2vy6nxvi0x9ee">
                <p className="text-lg text-ink-muted leading-relaxed" data-id="element-2566" data-mp="2rw1y77up4wx1">
                  <span className="font-semibold text-ink-dark" data-id="element-2567" data-mp="2n3iia48jdpp2">{scenario.setting}</span>{' '}
                  {scenario.need}
                </p>
              </li>)}
          </motion.ul>
          <motion.p {...fadeUp} className="mt-8 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-2568" data-mp="2d6dxo8uca2ad">
            SyNeural is designed to support each of these uses without treating
            them as the same task.
          </motion.p>
        </div>
      </section>
    </>;
}